import React from 'react';
import './MenuHeader.scss';
import MenuHeader2 from './MenuHeader2';
import MenuHeader3 from './MenuHeader3';

export default function MenuHeader({ hasBack, logo, onBack, onClose, title, hasNestedBack, onNestedBack }) {
  console.log('hasNestedBack', hasNestedBack)
  return (
    <div className="mobile-menu-header">
      <div className="mobile-menu-header-1">
        <span className="closex-btn" onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none">
            <path
              d="M18 2L2 18M2 2L18 18"
              stroke="#2F2F2F"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <a
          href="https://trinityconsultants.com/"
          className="custom-logo-link"
          rel="home"
          aria-current="page">
          {logo && (
            <img
              width={122}
              height={32}
              src={logo}
              className="custom-logo"
              alt="Trinity Consultants logo"
              decoding="async"
            />
          )}
        </a>
      </div>

      {hasBack && (
        // <div className="mobile-menu-header-2">
        //   <button className="back-btn" onClick={onBack}>
        //     ""
        //   </button>
        // </div>
        <MenuHeader2 onBack={onBack} hasBack={hasBack} />
      )}
      {/* {hasNestedBack && hasNestedBack != 'Resources' && <MenuHeader3 title={hasNestedBack} onBack={onNestedBack} hasNestedBack={hasNestedBack} />} */}

      {/* <h3 className="menu-title">{title}</h3> */}
    </div>
  );
}
